import { ranking } from "@/mocks/ranking";

const trendMap = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600" },
  flat: { icon: "ri-subtract-line", className: "text-foreground-400" },
  down: { icon: "ri-arrow-down-line", className: "text-accent-600" },
};

export default function RankList() {
  return (
    <section id="rank" className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-accent-700">导航站热榜</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              懒得挑？照着这份榜从前十往下点
            </h2>
          </div>
          <p className="text-xs text-foreground-600">按近 24 小时访问热度重排 · 每小时刷新一次</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-2.5 lg:grid-cols-2">
          {ranking.map((item) => {
            const trend = trendMap[item.trend];
            const isTop = item.rank <= 3;
            return (
              <a
                key={item.rank}
                href="#rank"
                className="flex cursor-pointer items-center gap-3 rounded-md border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-primary-300 md:gap-4 md:p-4"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                    isTop ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <span className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.name}
                    </span>
                    <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900">
                      {item.category}
                    </span>
                  </span>
                  <span className="mt-1 block truncate text-xs text-foreground-600">{item.note}</span>
                </span>
                <span className="flex shrink-0 flex-col items-end gap-1">
                  <span className="flex items-center gap-1 font-heading text-sm font-bold text-foreground-950">
                    <span className={`flex h-4 w-4 items-center justify-center ${trend.className}`}>
                      <i className={`${trend.icon} text-sm`} />
                    </span>
                    {item.hot.toLocaleString()}
                  </span>
                  <span className="text-[10px] text-foreground-500">热度</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}